(function (Drupal, $, once) {
  'use strict';

  Drupal.behaviors.ucwsPaginationToggle = {

    attach: function (context, settings) {

      var blocks = $('.block.views-block.pagination-toggle');
      blocks.each(function () {

        // Add a 'Show all/Show less' button to toggle the state of the
        // hidden 'Items per page' dropdown from the view's 'exposed' form.
        var exposedForm = $(this).find('form');
        var itemsPerPageDropdown = exposedForm.find('.form-item-items-per-page select');

        var dropdownAllLabel = "All";
        var pager = $(this).find('nav.pager');
        var pagerSection = $(this).find('.pager-section');
        var showAllButton = $('<div class="show-all-btn-wrapper"><a class="show-all-button">Show all</a></div>');
        var showLessButton = $('<div class="show-less-btn-container"><div class="show-less-btn-wrapper"><a class="show-less-button">Show less</a></div></div>');

        if (itemsPerPageDropdown.val() !== dropdownAllLabel) {
          $(once('loaded', pager, context)).append(showAllButton);
        }
        else {
          $(once('loaded', pagerSection, context)).append(showLessButton);
        }

        var refreshForm = function () {
          exposedForm.find(':submit:not(.reset-button)').trigger('click');
        };

        pager.find('.show-all-button').on('click', function () {
          itemsPerPageDropdown.val('All');
          refreshForm();
        });

        pagerSection.find('.show-less-button').on('click', function () {
          itemsPerPageDropdown.val('10');
          refreshForm();
        });
      });
    }
  };
})(Drupal, jQuery, once);
